<div class="empty-list text-center mt-4">
  <p>
    <fa-icon [icon]="faFolderOpen" size="10x"></fa-icon>
  </p>
  <h3>{{ message }}</h3>
</div>
